declare global {
    interface Window {
        __PG_GTM_INITIALIZED__?: boolean;
    }
}

export const setGoogleTagManagerInitialized = () => {
    window.__PG_GTM_INITIALIZED__ = true;
};

export const isGoogleTagManagerInitialized = () => window.__PG_GTM_INITIALIZED__ === true;
declare global {
    interface Window {
        __PG_GTM_INITIALIZED__?: boolean;
    }
}

export const setGoogleTagManagerInitialized = () => {
    window.__PG_GTM_INITIALIZED__ = true;
};

export const isGoogleTagManagerInitialized = () => window.__PG_GTM_INITIALIZED__ === true;
